export enum ShiftManagerTab {
  Payments = 'payments',
  RiskPayments = 'risk-payments',
  CompliancePayments = 'compliance-payments',
  Organizations = 'organizations',
  Businesses = 'businesses'
}
